
import { TutorialStep } from "@/components/tutorial/TutorialSpotlight";

// Export the tutorial steps for the Home page
export const homePageTutorial: TutorialStep[] = [
  {
    target: "h1",
    title: "Benvenuto in Ceralia",
    content: "Questa è la tua dashboard personale dove puoi gestire tutte le tue liste della spesa."
  },
  {
    target: "[data-tutorial='primary-list-section']",
    title: "Lista Principale",
    content: "Qui trovi la tua lista principale della spesa. Puoi aggiungere rapidamente gli articoli più utilizzati che hai acquistato negli ultimi 30 giorni."
  },
  {
    target: "[data-tutorial='most-purchased']",
    title: "Prodotti Più Acquistati",
    content: "Questa sezione mostra i prodotti che acquisti più frequentemente per aggiungerli rapidamente alla lista."
  },
  {
    target: "[data-tutorial='upcoming-products']",
    title: "Prodotti Ricorrenti",
    content: "Gestisci qui i prodotti che acquisti regolarmente con promemoria automatici."
  },
  {
    target: ".tutorial-target-homepage-add-list-button",
    title: "Crea Nuova Lista",
    content: "Tocca questo pulsante per creare una nuova lista della spesa."
  }
];
